import request from "@/utils/request";

export function getPublications(params) {
  return request({
    url: "/api/admin/publication/",
    method: "get",
    params,
  });
}

export function getPublication(id) {
  return request({
    url: `/api/admin/publication/${id}/`,
    method: "get",
  });
}

export function createPublication(data) {
  return request({
    url: "/api/admin/publication/",
    method: "post",
    data,
  });
}

export function updatePublication(id, data) {
  return request({
    url: `/api/admin/publication/${id}/`,
    method: "patch",
    data,
  });
}

export function deletePublication(id) {
  return request({
    url: `/api/admin/publication/${id}/`,
    method: "delete",
  });
}

export function addPublicationGalleryItem(publicationId, data) {
  return request({
    url: `/api/admin/publication/${publicationId}/gallery/`,
    method: "post",
    data,
  });
}

export function updatePublicationGalleryItem(
  publicationId,
  galleryItemId,
  data
) {
  return request({
    url: `/api/admin/publication/${publicationId}/gallery/${galleryItemId}`,
    method: "patch",
    data,
  });
}

export function deletePublicationGalleryItem(publicationId, galleryItemId) {
  return request({
    url: `/api/admin/publication/${publicationId}/gallery/${galleryItemId}`,
    method: "delete",
  });
}

export function addPublicationRelated(publicationId, data) {
  return request({
    url: `/api/admin/publication/${publicationId}/related/`,
    method: "post",
    data,
  });
}

export function deletePublicationRelated(publicationId, relationId) {
  return request({
    url: `/api/admin/publication/${publicationId}/related/${relationId}`,
    method: "delete",
  });
}
